import { IconNoteOnPaper } from '../../../../assets/DesignSystem/SVGComponents';
import './CheckOrAddCommentsButton.scss';

interface ICheckOrAddCommentsButton {
  openModal: () => void,
  notNeedRenderCommentText?: boolean,
}

const CheckOrAddCommentsButton = ({ openModal, notNeedRenderCommentText }: ICheckOrAddCommentsButton) => {

  return (
    <div className='checkOrAddCommentsButton' onClick={openModal}>
      <IconNoteOnPaper className="iconNoteOnPaper" />
      {!notNeedRenderCommentText && (
        <span className="commentsText">Chat Interno</span>
      )}
    </div>
  );
};



export default CheckOrAddCommentsButton;
